import { Season } from '../../models/season.model';

/**
 * Extracts a season ID from a tournament name by checking if the name contains
 * any of the provided season IDs
 * @param tournamentName - The tournament name to parse
 * @param seasons - Array of seasons to check against
 * @returns The matching season ID if found, otherwise null
 */
export const extractSeasonFromTournamentName = (
  tournamentName: string,
  seasons: Season[],
): string | undefined => {
  if (!tournamentName || !seasons || seasons.length === 0) {
    return undefined;
  }

  // Convert tournament name to lowercase for case-insensitive matching
  const lowerTournamentName = tournamentName.toLowerCase();

  // Check each season to see if its ID is contained in the tournament name
  for (const season of seasons) {
    if (
      season.seasonId &&
      lowerTournamentName.includes(season.seasonId.toLowerCase())
    ) {
      return season.seasonId;
    }
  }

  return undefined;
};
